import type { PeopleGroup } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

type PeopleGroupItem =
  | PeopleGroup["employees"][number]
  | PeopleGroup["residents"][number];

const toMultiSelectItem = (item: PeopleGroupItem): IMultiSelectItem => {
  return {
    id: item.id,
    title: `${item.name?.trim()} ${item.surname?.trim()}`.trim(),
    imageURL: item.image?.source,
    blurhash: item.image?.blurhash,
  };
};

const toOption = (item: PeopleGroupItem): IOption => {
  return {
    value: item.id,
    title: item.name || "",
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
